import { render, staticRenderFns } from "./WeathersHome.vue?vue&type=template&id=b2645c22"
import script from "./WeathersHome.vue?vue&type=script&lang=js"
export * from "./WeathersHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports